import moment from 'moment';
import momentTZ from 'moment-timezone';

export function yesterday() {
  return moment(Date.now()).subtract(1, 'days').format('YYYY-MM-DD');
}

export function tomorrow() {
  return moment(Date.now()).add(1, 'days').format('YYYY-MM-DD');
}

export function today() {
  return moment(Date.now()).format('YYYY-MM-DD');
}

export function plusOneDay(date) {
  return moment(date).add(1, 'days').format('YYYY-MM-DD');
}

export function minusOneDay(date) {
  return moment(date).subtract(1, 'days').format('YYYY-MM-DD');
}

export function aMouthAgo() {
  return moment(Date.now()).subtract(1, 'months').format('YYYY-MM-DD');
}

export function startOfMouth() {
  return moment().clone().startOf('month').format('YYYY-MM-DD');
}

export function endOfMouth() {
  return moment().clone().endOf('month').format('YYYY-MM-DD');
}

export function toUTC(date, time) {
  const datetime = date + 'T' + time;
  // console.log('datetime', datetime);
  return moment(datetime, moment.ISO_8601).utc().format();
}

export function toLocal(datetime) {
  return momentTZ(datetime).tz('Asia/Taipei').format('YYYY-MM-DD HH:mm');
}

export function timeFormat(datetime) {
  console.log('datetime', datetime);
  return moment(datetime).format('YYYY/MM/DD HH:mm');
}
